import { render, staticRenderFns } from "./AsociarProveedor.vue?vue&type=template&id=4bfe8e19&"
import script from "./AsociarProveedor.vue?vue&type=script&lang=ts&"
export * from "./AsociarProveedor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4bfe8e19', component.options)
    } else {
      api.reload('4bfe8e19', component.options)
    }
    module.hot.accept("./AsociarProveedor.vue?vue&type=template&id=4bfe8e19&", function () {
      api.rerender('4bfe8e19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Informes/ContainerInformeDescargas/AsociarProveedor.vue"
export default component.exports